const init = () => {
  const modals = document.querySelectorAll('[data-modal]')

  modals.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()
      const modal = document.getElementById(trigger.dataset.modal)
      modal.classList.add('open')
      const exits = modal.querySelectorAll('.close-modal')
      exits.forEach((exit) => {
        exit.addEventListener('click', (event) => {
          event.preventDefault()
          modal.classList.remove('open')
        })
      })
    })
  })
}

export default {
  init
}
